import { get } from '@core/api/baseApi';
import { UserOrganizationModel } from '@core/types';

const getUserOrganizations = (): Promise<UserOrganizationModel[]> => get('/user/organizations');

export default getUserOrganizations;
